
    function __html_es6_template_loader__() {
      return `<div id="injected-header"> <header role="banner" class="region--banner"> <div class="banner-navbar"> <div class="banner-navbar--container"> <h1 class="banner-navbar--title"> <a href="https://online.stanford.edu/" title="Home" rel="home" tabindex="0">Stanford Online</a> </h1> </div> </div> </header> </div> `;
    }
    module.exports = function(context) {
      return __html_es6_template_loader__.call(context, context);
    }
  


// WEBPACK FOOTER //
// ./includes/header.html